export enum Res {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export enum PaymentType {
  Paypal = 'paypal',
  Card = 'card',
  External = 'external',
  NoPaid = 'noPaid',
  Stripe = 'stripe',
}

export type WhiteLabel = {
  domainUrl: string;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  website: string;
  active?: string;
};

export type TTheme = {
  device?: {
    mobile: boolean;
    //mobile + horizontal view
    landscape: boolean;
    ios: boolean;
    tablet: boolean;
  };
};
